import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/**
 * SortableEntity — @dnd-kit sortable wrapper that hands a drag-handle
 * listener bag to whatever child card renders inside.
 *
 * The card component is passed via `renderCard({ dragHandleProps, isDragging })`
 * so we don't fork CompactEntityCard for reorderable vs. static modes.
 * `dragHandleProps` = { ...attributes, ...listeners } — attach to the grip
 * icon so the whole card body stays a normal click-to-open surface.
 *
 * Only mounted when the parent HQ grid is in Custom sort mode; every other
 * mode renders the card directly and never enters the DnD tree.
 */
export default function SortableEntity({ id, renderCard }) {
  const {
    attributes, listeners, setNodeRef, setActivatorNodeRef,
    transform, transition, isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 30 : "auto",
  };

  const dragHandleProps = {
    ref: setActivatorNodeRef,
    ...attributes,
    ...listeners,
  };

  return (
    <div ref={setNodeRef} style={style} data-testid={`sortable-${id}`}>
      {renderCard({ dragHandleProps, isDragging })}
    </div>
  );
}
